"use client";

import { useFormStatus } from "react-dom";

import { Button, type ButtonProps } from "../core/Button";

export type SubmitButtonProps = Omit<ButtonProps, "type" | "href" | "as">;

/**
 * El botón que envía el `<form>` que lo contiene. Lee `useFormStatus`, así que
 * mientras el server action corre muestra el spinner y no admite otro clic;
 * quien lo usa no cablea nada. `pending` explícito se suma al del formulario.
 */
export function SubmitButton({ pending, ...rest }: SubmitButtonProps) {
  const { pending: enviando } = useFormStatus();
  return <Button type="submit" pending={pending || enviando} {...rest} />;
}
